export const productMainQueryKey = "products";
